import { ROUTE_PPRA_PAYMENT } from '@/constants/routes';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import useOnMount from '@/hooks/useOnMount';
import useVisitorSession from '@/hooks/useVisitorSession';

import authService from '@/services/auth.service';
import { useToast } from '@cmpsr/components';
import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

export default function useSignUpController() {
  const navigate = useNavigate();
  const { captureLead, initializeSession, email } = useVisitorSession();
  const form = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', defaultValues: { email: '' } });
  const toast = useToast();
  const inviteCode = authService.getInviteCode() || undefined;

  const handleCta = useCallback(() => {
    navigate(ROUTE_PPRA_PAYMENT, { replace: true });
  }, [navigate]);

  useOnMount(() => {
    document.title = 'Sign Up';
    initializeSession();
  });

  // If the user has an email, we can assume they've already signed up and we can redirect them to the payment page
  useEffect(() => {
    if (email) {
      handleCta();
    }
  }, [email, handleCta]);

  function handleBack() {
    return navigate(-1);
  }

  const handleSubmit = form.handleSubmit((values) => {
    captureLead(values.email, inviteCode)
      .then((res) => {
        handleCta();
      })
      .catch((error) => {
        console.error(error);
        toast({
          ...TOAST_DEFAULT_OPTIONS,
          title: `Error ${error.response?.data?.statusCode ?? ''}`,
          description: error.response?.data?.message ?? error.message,
          status: 'error',
        });
      });
  });

  return {
    form,
    handleSubmit,
    handleBack,
  };
}
